import { type Guide } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useGetActiveGuides = requestBuilder.query<Guide[]>({
    endpoint: '/api/signup/guides',
    queryKey: 'getActiveGuides',
});
